module.exports = __webpack_public_path__ + "static/media/walking6.695d40db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/walking6.png
// module id = 2043
// module chunks = 0